export const MIN_USEFUL_ITEM_COUNT = 50;
export const COMPLETE_ITEM_COUNT = 150;

/**
 * Classify the dashboard's item-catalog setup step.
 *
 * Zero is intentionally its own incomplete state. Treating zero as the absence
 * of a step makes an empty store fall through to the dashboard's "all clear"
 * message even though the shared setup-progress service still requires items.
 */
export function getSetupCatalogReadiness(totalItems) {
  const parsed = Number(totalItems);
  const count = Number.isFinite(parsed) ? Math.max(0, Math.floor(parsed)) : 0;

  if (count === 0) return { count, band: 'empty', tone: 'amber', partial: false };
  if (count < MIN_USEFUL_ITEM_COUNT) return { count, band: 'started', tone: 'amber', partial: false };
  if (count < COMPLETE_ITEM_COUNT) return { count, band: 'partial', tone: 'amber', partial: true };
  return { count, band: 'complete', tone: 'green', partial: false };
}
